import React from 'react';
import { createRoot } from 'react-dom/client';
import * as smoothscroll from 'smoothscroll-polyfill';
import * as setup from './setup';
import { EmpApp, BaseLayout } from '@src/routers';

smoothscroll.polyfill();

const logger = console;
let root = null as any;
const render = (props) => {
  const { container = document.body, isWidget = false } = props;

  const $app = (
    <BaseLayout isWidget={isWidget}>
      <EmpApp />
    </BaseLayout>
  );

  setup.start();
  if (!root) {
    root = createRoot(container.querySelector('#emp'));
  }
  root.render($app);
};

if (!window.__POWERED_BY_QIANKUN__) {
  // const props = {isWidget: true, widgetName: 'FlowDrawer', widgetProps: {drawerProps: {open: true}}};
  const props = {};
  render(props);
}

export async function bootstrap() {
  logger.log('react app bootstraped');
}

export async function mount(props) {
  if (!window.conviva || !window.conviva.microProps) {
    Object.defineProperty(window.conviva, 'microProps', {
      value: props,
      writable: false,
    });
  }
  render(props);
}

export async function unmount(props) {
  const $app = props.container;
  if ($app) {
    if (!root) {
      root = createRoot($app.querySelector('#emp'));
    }
    root?.unmount();
    root = null;
  }
  setup.stop();
}

export async function update(props) {
  const mergedProps = {
    ...window.conviva?.microProps,
    ...props,
    widgetProps: {
      ...props.widgetProps,
    },
  };
  render(mergedProps);
}
